export default __webpack_public_path__ + "ffe3e1bbb06b22282159efcd0bd25ccf.svg";